import { render } from "./VerifyEmailView.vue?vue&type=template&id=17cbe64a"
import script from "./VerifyEmailView.vue?vue&type=script&lang=js"
export * from "./VerifyEmailView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__